import React from "react";
import { Link } from "react-router-dom";
import Layout from "components/Layout";
import VoucherPanel from "./VoucherPanel";
import "styles/konto.css";

const GutscheinePage = () => (
  <Layout>
    <section className="konto-page">
      <div className="konto-shell">
        <header className="konto-header">
          <div>
            <h1>
              <em>Gutscheine</em>
            </h1>
            <p>
              Löse einen Code ein. Danach kannst du ihn beim{" "}
              <Link to="/buchen">Buchen</Link> für genau diese Massage verwenden.
            </p>
          </div>
          <Link to="/shop" className="btn-primary">
            Gutschein kaufen
          </Link>
        </header>
        <VoucherPanel hideHead />
      </div>
    </section>
  </Layout>
);

export default GutscheinePage;
